import { c as _c } from "react/compiler-runtime";
import { MINIMUM_INVOICE_GROSZE } from '@algoacademy/backend/modules/payment/discount-pricing';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph';
import { formatGrosze } from '../../../_forms/MentoringOfferForm/_helpers/mentoring-terms';
import type { DiscountPreviewFigures } from '../_helpers/discount-preview';
type DiscountPreviewProps = {
  figures: DiscountPreviewFigures;
};

/**
 * What the price card above does not say. The card carries the whole ladder now
 * - list price, cadence price, what the discount charges, the invoice and the
 * totals - so printing those figures again here would only give staff two places
 * to read the same money, and two places to misread it. What is left is what
 * happens next: the floor this discount ran into, and the day it ends.
 */
export function DiscountPreview(t0) {
  const $ = _c(7);
  const {
    figures
  } = t0;
  const {
    ending,
    isAtMinimumInvoice
  } = figures;
  if (ending === null && !isAtMinimumInvoice) {
    return null;
  }
  let t1;
  if ($[0] !== isAtMinimumInvoice) {
    t1 = isAtMinimumInvoice ? <p role="status" className="rounded-lg border border-borderPrimary bg-backgroundSecondary p-4 text-contentSecondary text-sm">Ta zniżka sięga dna. Żadna faktura nie może kosztować mniej niż{" "}{formatGrosze(MINIMUM_INVOICE_GROSZE)}, więc kupujący zapłaci dokładnie tyle - głębsza zniżka niczego już nie obniży.</p> : null;
    $[0] = isAtMinimumInvoice;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== ending) {
    t2 = ending === null ? null : <P2 role="status" className="rounded-lg border border-contentBlue bg-backgroundBlue p-4 text-contentBlue text-sm">Kiedy zniżka się skończy, faktura wraca do {formatGrosze(ending.fullPriceGrosze)}.</P2>;
    $[2] = ending;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col gap-3">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}